import { z } from "zod/v4";

import {
  CreateExperienceCustomMetricDtoDescriptions,
  ExperienceCustomMetricDtoDescriptions,
} from "../descriptions/experience-custom-metric-dto.describe";
import { assertDescriptions } from "../descriptions/types";

import { CustomEventDtoSchema } from "./analytics-events/custom-events";

export const ExperienceCustomMetricDtoSchema = z.object({
  id: z.uuid().describe(ExperienceCustomMetricDtoDescriptions.id),
  experienceId: z
    .uuid()
    .describe(ExperienceCustomMetricDtoDescriptions.experienceId),
  order: z.number().describe(ExperienceCustomMetricDtoDescriptions.order),
  customEventId: z
    .uuid()
    .describe(ExperienceCustomMetricDtoDescriptions.customEventId),
  customEvent: CustomEventDtoSchema.describe(
    ExperienceCustomMetricDtoDescriptions.customEvent
  ),
});

export type ExperienceCustomMetricDto = z.infer<
  typeof ExperienceCustomMetricDtoSchema
>;

export const CreateExperienceCustomMetricDtoSchema =
  ExperienceCustomMetricDtoSchema.omit({
    customEvent: true,
  }).extend({
    experienceId: z
      .uuid()
      .optional()
      .describe(CreateExperienceCustomMetricDtoDescriptions.experienceId),
  });

export type CreateExperienceCustomMetricDto = z.infer<
  typeof CreateExperienceCustomMetricDtoSchema
>;

// Compile-time check: description object must cover all schema keys
assertDescriptions<
  typeof ExperienceCustomMetricDtoDescriptions,
  ExperienceCustomMetricDto
>();
